import axiosClient from "../axiosInstance";

/**
 * Ranking setup API: scoring tables, settings, per-organisation overrides,
 * and the lookup data the Add Entry form renders.
 */

const base = "/admin/setup";

export const getSetupOverview = async () => {
  const response = await axiosClient.get(`${base}/overview`);
  return response.data;
};

export const createSetupRow = async (table, payload) => {
  const response = await axiosClient.post(`${base}/${table}`, payload);
  return response.data;
};

export const updateSetupRow = async (table, id, payload) => {
  const response = await axiosClient.put(`${base}/${table}/${id}`, payload);
  return response.data;
};

export const deleteSetupRow = async (table, id) => {
  const response = await axiosClient.delete(`${base}/${table}/${id}`);
  return response.data;
};

export const updateSettings = async (payload) => {
  const response = await axiosClient.put(`${base}/settings`, payload);
  return response.data;
};

export const getOverrides = async (organisationId) => {
  const response = await axiosClient.get(`${base}/overrides`, {
    params: { organisation_id: organisationId },
  });
  return response.data;
};

export const getEffectiveAllocations = async (organisationId) => {
  const response = await axiosClient.get(`${base}/effective`, {
    params: { organisation_id: organisationId },
  });
  return response.data;
};

export const saveOverrides = async (organisationId, overrides) => {
  const response = await axiosClient.put(`${base}/overrides`, {
    organisation_id: organisationId,
    overrides,
  });
  return response.data;
};

/** Dropdown data for the Add Entry form (any logged-in user). */
export const getLookup = async () => {
  const response = await axiosClient.get("/public/lookup");
  return response.data;
};

const setupService = {
  getSetupOverview,
  createSetupRow,
  updateSetupRow,
  deleteSetupRow,
  updateSettings,
  getOverrides,
  getEffectiveAllocations,
  saveOverrides,
  getLookup,
};

export default setupService;
